import { buildInitialValues } from '../helpers'
import { type TotalWidgetSettings } from './totalWidgetSettingsSchema'

const DEFAULT_FONT_COLOR = 'ffffff'
const DEFAULT_DATA_FONT_COLOR = '9ECB0A'
const DEFAULT_FONT = 'Fira Sans'
const DEFAULT_FONT_WEIGHT = 700
const DEFAULT_FONT_SIZE = 32

const defaultValues = {
  darkMode: true,
  textAlign: 'center',
  countOfLines: 'multi',

  headlineFont: DEFAULT_FONT,
  headlineFontWeight: DEFAULT_FONT_WEIGHT,
  headlineFontSize: DEFAULT_FONT_SIZE,
  headlineFontColor: DEFAULT_FONT_COLOR,
  headlineText: 'Spendenstand',

  dataFont: DEFAULT_FONT,
  dataFontWeight: DEFAULT_FONT_WEIGHT,
  dataFontSize: DEFAULT_FONT_SIZE,
  dataFontColor: DEFAULT_DATA_FONT_COLOR,
} satisfies TotalWidgetSettings

const getDefaultValues = buildInitialValues(defaultValues)
export default getDefaultValues
